import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import ChangePassword from '@/pages/ChangePassword';

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force one-time password change before granting access to anything else.
  // The /change-password route itself is allowed through so users can submit the change.
  if (user.must_change_password && location.pathname !== '/change-password') {
    return <ChangePassword forced onSuccess={() => { checkAuth?.(); }} />;
  }

  return children;
};

export default ProtectedRoute;
